import { Cluster } from '@cast/types';

import { PRODUCT_BASE_PATHS } from '@cast/console-constants';
import { isDisconnectedForMonth } from 'features/cluster';

import { SidebarItem } from '../../_components/SidebarItem';

type Props = {
  cluster: Cluster;
};

export const SavingsSidebarItem = (props: Props) => {
  const basePath = `${PRODUCT_BASE_PATHS.automation}/external-clusters/${props.cluster.id}`;
  const isDisconnected = isDisconnectedForMonth(props.cluster);

  return (
    <SidebarItem
      title="Available savings"
      url={`${basePath}/available-savings`}
      disabled={isDisconnected}
    />
  );
};
